import React, { ReactElement } from 'react';
import { Column, Grid, Box } from 'lmc-ui-library';

import styles from '../RegistrationFormTemplate.module.scss';

type Props = {
  children: ReactElement | ReactElement[];
  wrapperStyles?: React.CSSProperties;
};

const BoxWrapper: React.FC<Props> = ({ children, wrapperStyles }) => {
  return (
    <Box style={wrapperStyles}>
      <Box.Content className={styles.registrationBox}>
        <Grid cols={12}>
          <Column lg={7} md={9} sm={12} xs={12}>
            {children}
          </Column>
        </Grid>
      </Box.Content>
    </Box>
  );
};

export default BoxWrapper;
